<ion-row>
  <ion-col>
    <ion-text [innerHTML]="translationKey + '.win_dialog.text' | translate:{ solutionword: solutionWord, duration: duration, moveCounter: moveCounter }"></ion-text>
  </ion-col>
</ion-row>
<ion-row *ngIf="data.solutionWord || data.solutionOriginal">
  <ion-col>
    <ion-text>{{translationKey + '.win_dialog.solution_message' | translate}}</ion-text>
  </ion-col>
</ion-row>
<ion-row *ngIf="data.solutionWord || data.solutionOriginal">
  <ion-col>
    <lib-app-puzzle-solution-word-animation class="swedish-win-screen-animation"
                                            [solutionWord]="data.solutionWord" [solutionOriginal]="data.solutionOriginal">
    </lib-app-puzzle-solution-word-animation>
  </ion-col>
</ion-row>
<ion-row *ngIf="data.sayingText || data.solutionOriginal">
  <ion-col>
    <ion-text>{{translationKey + '.win_dialog.saying_message' | translate}}</ion-text>
  </ion-col>
</ion-row>
<ion-row *ngIf="data.sayingText || data.solutionOriginal">
  <ion-col>
    <lib-app-puzzle-solution-word-animation class="swedish-win-screen-animation"
                                            [solutionWord]="data.sayingText" [solutionOriginal]="data.sayingOriginal">
    </lib-app-puzzle-solution-word-animation>
  </ion-col>
</ion-row>



